// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6183 ? "e89fb3a8" : chunkId) + "." + {"136":"57a71fe9ada95e7f","4889":"95ad8b194eda847d","6183":"a49f8b0164d790a3"}[chunkId] + ".js";
};